import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {ICheckboxGroupFieldConfig, IControl} from "../../../../service/booking/IQualityCheck";
import {Subscription} from "rxjs";
import {Yii} from "../../../../interfaces/Yii";
import {NotificationType} from "../../../../interfaces/INotification";


@Component({
    selector: 'checkbox-group-field',
    template: `
        <notification [type]="type">{{ infoMsg }}</notification>
        <div class="box">
            <ng-container *ngFor="let qualityCheckItem of formattedQualityCheckList;">
                <collapsible-with-checkbox
                        [title]="qualityCheckItem.operationName | capitalizeFirstLetter" [open]="open"
                        [hasCheckbox]="true"
                        [idCheckbox]="qualityCheckItem.operationCode"
                        [isChecked]="isCheckedOperations[qualityCheckItem.operationCode]"
                        [nameCheckbox]="qualityCheckItem.operationName"
                        (onCheckAll)="checkUncheckAll($event, qualityCheckItem.operationCode)">
                    <div class="controls">
                        <ng-container *ngFor="let control of qualityCheckItem.controls;">
                            <checkbox-field [title]="control.controlName" [addLabelEllipsis]="true" [fieldConfig]="{
                        checkboxLabel: control.controlName,
                        disableRipple: true,
                        formGroup: controlsForm,
                        formControlName: control.controlCode
                    }"
                                            [isSmallHeight]="true"></checkbox-field>
                        </ng-container>
                    </div>
                </collapsible-with-checkbox>

            </ng-container>
        </div>
    `,
    styles: [`
        .box {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
            border: solid 2px rgb(217, 217, 217);
            padding: 10px;
            justify-content: space-between;
            overflow: hidden;
        }

        collapsible-with-checkbox {
            margin: 10px 0;
            max-width: calc(50% - 10px);
            min-width: calc(50% - 10px);
            display: block;
        }

        .controls {
            padding-top: 7px;
        }

        notification {
            margin: 10px 0;
        }
    `],
})
export class CheckboxGroupFieldComponent implements OnInit, OnDestroy {
    //search form
    @Input()
    public form: FormGroup;
    @Input()
    public formattedQualityCheckList: ICheckboxGroupFieldConfig[];
    // Form contenant les checkbox de tous les controles (pas les operations)
    public controlsForm: FormGroup;
    public isCheckedOperations: { [key: string]: boolean } = {};
    public readonly infoMsg: string = Yii.t("wui-shared-js", "Attention ! seuls les contrôles en echec seront affichés");
    public type: NotificationType = NotificationType.Info;
    private formChangeSubscription: Subscription;

    // pré fermer/ouvrir les collapses des operations
    public open: boolean = true;

    public ngOnInit(): void {
        this.initControlsForm();
        if (this.controlsForm) {
            this.initIsCheckedOperations(this.controlsForm.value);
            this.initFormChangeSubscription();
        }
    }

    public ngOnDestroy(): void {
        if (this.formChangeSubscription) {
            this.formChangeSubscription.unsubscribe();
        }
    }

    // Check Uncheck tous les controles d'une operation coché
    public checkUncheckAll(isChecked: boolean, operationCode: string): void {
        this.formattedQualityCheckList
            .filter((qualityCheckItem: ICheckboxGroupFieldConfig) => qualityCheckItem.operationCode === operationCode)[0].controls
            .forEach((control: IControl) => {
                this.controlsForm.get(control.controlCode).setValue(isChecked);
            });
    }

    private initControlsForm(): void {
        const controls: { [key: string]: FormControl } = {};
        this.formattedQualityCheckList.forEach((qualityCheckItem: ICheckboxGroupFieldConfig): void => {
            qualityCheckItem.controls.forEach((control: IControl): void => {
                const isControlChecked: boolean = this.form.get('qualityCheck').value && this.form.get('qualityCheck').value.length && this.form.get('qualityCheck').value.includes(control.controlCode);
                controls[control.controlCode] = new FormControl(isControlChecked);
            });
        });
        this.controlsForm = new FormGroup(controls);
    }

    //Check l'operation si tous les controles sont checked et l'inverse
    private initIsCheckedOperations(formValues: any): void {
        this.formattedQualityCheckList.forEach((qualityCheckItem: ICheckboxGroupFieldConfig) => {
            this.isCheckedOperations[qualityCheckItem.operationCode] = qualityCheckItem.controls
                .every((control: IControl): boolean => Boolean(formValues[control.controlCode]));
        });
    }

    private setFormQualityCheckValues(): void {
        const controlCodesArray: string[] = [];
        this.formattedQualityCheckList.forEach((qualityCheckItem: ICheckboxGroupFieldConfig) => {
            qualityCheckItem.controls.forEach((control: IControl) => {
                if (this.controlsForm.value[control.controlCode] === true) {
                    controlCodesArray.push(control.controlCode);
                }
            });
        });
        this.form.get('qualityCheck').setValue(controlCodesArray);
    }

    // s'abonne au changement du formulaire controlsForm
    private initFormChangeSubscription(): void {
        this.formChangeSubscription = this.controlsForm.valueChanges
            .subscribe((formValues: any): void => {
                //Check l'operation si tous les controles sont checked et l'inverse
                this.initIsCheckedOperations(formValues);
                // remplir le field qualityCheck du formulaire de recherche (form) par les codes controle
                this.setFormQualityCheckValues();
            });
    }
}
